<template>
	<div>
		<div class="gridM" v-show='vw >=640'>
			<ul class="grid">
				<li v-for="item in items">
					<div class="item" >
						<a :href=item.link class="imgContainer" :style='`background-image: url("${item.img}")`'></a>
						<div class="articleText">
							<a v-for="ttl in item.title" :href=ttl.linkArticle class="title">{{ttl.article}}</a>
							<a :href=item.link class="description">{{item.description}}</a>
							<div class="bottomInfo">
								<p class="data">{{item.data}}</p>
								<p class="see">{{item.see}}
									<svg  viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
										<path d="M0 0h24v24H0z" fill="none"/>
										<path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
									</svg>
								</p>
								<p class="feed">{{item.feed}}
									<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
										<path d="M0 0h24v24H0V0z" fill="none"/>
										<path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"/>
									</svg>
								</p>
							</div>
						</div>
					</div>
				</li>
			</ul>
		</div>

		<div class="sliderS" v-show='vw <640'>
			<div class="owl-carousel">
				<!-- <pre>{{data}}</pre> -->
				<template v-for="item in items">
					<div class="item" >
						<a :href=item.link class="imgContainer" :style='`background-image: url("${item.img}")`'></a>
						<div class="articleText">
							<a :href=item.linkArticle class="title" v-for="ttl in item.title">{{ttl.article}}</a>
							<a :href=item.link class="description">{{item.description}}</a>
							<div class="bottomInfo">
								<p class="data">{{item.data}}</p>
								<p class="see">{{item.see}}
									<svg  viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
										<path d="M0 0h24v24H0z" fill="none"/>
										<path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
									</svg>
								</p>
								<p class="feed">{{item.feed}}
									<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
										<path d="M0 0h24v24H0V0z" fill="none"/>
										<path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"/>
									</svg>
								</p>
							</div>
						</div>
					</div>
				</template>
			</div>
		</div>
	</div>

</template>

<script>
module.exports = {

	props: ['data'],

	data () {
		return {
			vw: $(window).width()
		}
	},



	updated() {
		console.log('work');
		this.$emit('updated', {
			owlSettings: {
				items: 1,
				loop: this.items.length > 1 ? true : false,
				margin: 0,
				dots: true,
				loop: true,
				touchDrag: true,
				mouseDrag: true,
				autoplay: true
			}
		});
	},

	computed: {
		items() {
			return this.data.items || {};
		}
	},

	mounted() {
		items = [],
		console.log('mounted');
		$(window).resize(() => {
			this.vw = $(window).width();
			console.log(this.vw);
		})

	},
}
</script>

<style lang="scss">
@import "scss/wanted";
.global-slider-container {

	.slider-smallslider {
		position: relative;
		margin-bottom: 15px;
		// @include m_up{
		// 	display: none;
		// };

		.owl-dots {
			position: absolute;
			bottom: -50px;
			width: 100%;
			text-align: center;
			z-index: 2;

			.owl-dot {
				display: inline-block;
				width: 12px;
				height: 12px;
				background-color: #97999c;
				@include border-radius(100%);
				// border: 2px solid #97999c;
				border: 2px solid #F9F9F9;
				cursor: pointer;
				margin: 0 5px 0 0;
				@include single-transition(all, 300ms, ease);

				&:hover, &.active {
					border-color: #97999C;
					background-color: transparent;
					@include single-transition(all, 300ms, ease);
				}
			}
		}
		.owl-carousel {

		}
	}
	.item {
		display: flex;
		flex-direction: column;
		border-radius: 3px;
		background-color: white;
		.imgContainer{
			width: 100%;
			height: 220px;
			display: block;
			background-position: center;
			background-repeat: no-repeat;
			background-size: cover;
		}
		.articleText{
			display: block;
			padding: 25px 30px 20px;


			.title{
				font-size: rem(10);
				letter-spacing: .075em;
				color: rgba(#303339, .5);
				text-transform: uppercase;
				text-decoration: none;
				display: inline-block;
				font-family: 'Conv_CirceBold';
				padding: 12px 7px 8px 7px;
				line-height: 1;
				border: 1px solid rgba(#303339, .5);
				border-radius: 15px;
				margin-bottom: 18px;
				margin-right: 5px;
			}
			.description{
				display: block;
				font-size: rem(20);
				line-height: 28px;
				letter-spacing: .025px;
				color: #303339;
				margin-bottom: 14px;
				text-decoration: none;
				overflow: hidden;
				@include m___only{
					font-size: rem(18);
					line-height: 24px;
					margin-bottom: 9px;
					height: 72px;
				};
				@include l_up{
					margin-bottom: 18px;
				};
				&:hover{
					text-decoration: underline;
				}
			}
			.bottomInfo{
				display: flex;
				font-size: rem(12);
				line-height: rem(22);
				letter-spacing: .001em;
				color: rgba(#303339, .5);
				p{
					padding-right: 20px;
					position: relative;
					svg{
						width: 16px;
						height: 14px;
						position: absolute;
						left: 0;
						top: calc(50% - 7px);
						fill: #97999c;
					}
					&.data{
						font-weight: bold;
					}
					&.see{
						padding-left: 20px;
					}
					&.feed{
						padding-left: 20px;
					}
				}
			}
		}
	}

	.gridM{
		@include m_up{
			.grid{
				@include block-grid(2, 30px);
				display: flex!important;
				flex: 1 1 auto;
				@include m___up{
					@include block-grid(4, 30px);
				}
			}
		};
	}

}
</style>



// WEBPACK FOOTER //
// smallSlider.vue?09cdb6f1